export default __webpack_public_path__ + "static/media/LockGray.fa48324f.svg";